import { render, staticRenderFns } from "./PositionDoughnutChart.vue?vue&type=template&id=0f8ba360&scoped=true&"
import script from "./PositionDoughnutChart.vue?vue&type=script&lang=js&"
export * from "./PositionDoughnutChart.vue?vue&type=script&lang=js&"
import style0 from "./PositionDoughnutChart.vue?vue&type=style&index=0&id=0f8ba360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8ba360",
  null
  
)

export default component.exports